import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

const LoginModal = ({ 
  closeModal, 
  isRegistering, 
  setIsRegistering,
  email, setEmail,
  password, setPassword,
  username, setUsername,
  handleRegister,
  handleLogin,
  handleGoogleSignIn,
  handleTwitterSignIn 
}) => {
  const { t } = useTranslation();
  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={handleGoogleSignIn} className="btn btn-google">
          <svg className="google-icon" viewBox="0 0 24 24">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          <span>{t('login.googleLogin')}</span>
        </button>

        <button onClick={handleTwitterSignIn} className="btn btn-twitter">
          <svg className="twitter-icon" viewBox="0 0 24 24">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" fill="currentColor"/>
          </svg>
          <span>{t('login.twitterLogin')}</span>
        </button>

        <div className="divider">{t('login.or')}</div>

        <h2>{isRegistering ? t('login.register') : t('login.title')}</h2>
        
        {isRegistering && (
          <div className="form-group">
            <label>{t('login.username')}</label>
            <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} placeholder={t('login.usernamePlaceholder')} />
          </div>
        )}

        <div className="form-group">
          <label>{t('login.email')}</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t('login.emailPlaceholder', 'E-posta adresiniz')} />
        </div>
        <div className="form-group">
          <label>{t('login.password')}</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder={t('login.passwordPlaceholder', 'Şifre')} />
        </div>

        {isRegistering ? (
          <button onClick={handleRegister} className="btn btn-primary">{t('login.registerButton')}</button>
        ) : (
          <button onClick={handleLogin} className="btn btn-primary">{t('login.loginButton')}</button>
        )}
        <button onClick={closeModal} className="btn btn-secondary">{t('settings.cancel')}</button>

        <p style={{marginTop: '15px', cursor: 'pointer', fontSize: '0.9em'}} onClick={() => setIsRegistering(!isRegistering)}>
          {isRegistering ? t('login.alreadyHaveAccount') : t('login.noAccount')}
        </p>
      </div>
    </div>
  );
};

export default LoginModal;